var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M11.5 9.624L11.5 6.376 15.5 4.319 15.5 11.681z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M15,5.139v5.722l-3-1.543V6.682L15,5.139 M16,3.5l-5,2.571v3.857l5,2.571V3.5L16,3.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#bae0bd",
    d: "M2.5,12.5c-1.103,0-2-0.897-2-2v-5c0-1.103,0.897-2,2-2h7c1.103,0,2,0.897,2,2v5 c0,1.103-0.897,2-2,2H2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5e9c76",
    d: "M9.5,4C10.327,4,11,4.673,11,5.5v5c0,0.827-0.673,1.5-1.5,1.5h-7C1.673,12,1,11.327,1,10.5v-5 C1,4.673,1.673,4,2.5,4H9.5 M9.5,3h-7C1.119,3,0,4.119,0,5.5v5C0,11.881,1.119,13,2.5,13h7c1.381,0,2.5-1.119,2.5-2.5v-5 C12,4.119,10.881,3,9.5,3L9.5,3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.2a98e7d1e23d4051443785131d42dcf9.svg";
export { ForwardRef as ReactComponent };